import { TextField, Box } from '@mui/material'
import { useEffect } from 'react'
import { useBirthDateInput } from './useBirthDateInput'

type Props = {
  onSuccess?: () => void
  onError?: (error: string) => void
  onSubmitStateChange?: (state: 'can' | 'disabled' | 'submitting') => void
  formId?: string
}

/**
 * 生年月日入力フォーム
 *
 * 内部でuseBirthDateInputを使用し、submit_stateを親に通知
 */
export const BirthDateInputForm: React.FC<Props> = ({
  onSuccess,
  onError,
  onSubmitStateChange,
  formId = 'birth-date-form'
}) => {
  const {
    year,
    month,
    day,
    error,
    is_submitting,
    currentYear,
    submit_state,
    setYear,
    setMonth,
    setDay,
    handleSubmit
  } = useBirthDateInput({ onSuccess, onError })

  const has_error = !!error

  // submit_stateが変更されたら親に通知
  useEffect(() => {
    onSubmitStateChange?.(submit_state)
  }, [submit_state, onSubmitStateChange])

  return (
    <form
      id={formId}
      onSubmit={(e) => {
        e.preventDefault()
        handleSubmit()
      }}
    >
      <Box display="flex" gap={2} mb={2}>
        <TextField
          type="number"
          label="年"
          value={year}
          onChange={(e) => setYear(e.target.value)}
          placeholder="1990"
          slotProps={{ htmlInput: { min: 1900, max: currentYear } }}
          variant="standard"
          sx={{ flex: 2 }}
          disabled={is_submitting}
          error={has_error}
          helperText={has_error ? error : ''}
        />

        <TextField
          type="number"
          label="月"
          value={month}
          onChange={(e) => setMonth(e.target.value)}
          placeholder="1"
          slotProps={{ htmlInput: { min: 1, max: 12 } }}
          variant="standard"
          sx={{ flex: 1 }}
          disabled={is_submitting}
        />

        <TextField
          type="number"
          label="日"
          value={day}
          onChange={(e) => setDay(e.target.value)}
          placeholder="1"
          slotProps={{ htmlInput: { min: 1, max: 31 } }}
          variant="standard"
          sx={{ flex: 1 }}
          disabled={is_submitting}
        />
      </Box>
    </form>
  )
}
